// Node Modules
import React from "react";

// Global Components
import Image from "components/image/image";

import DashedLineBreakHeader from "../components/dashedLineBreakHeader/dashedLineBreakHeader";

// Local Assets
import HempImage from "./assets/hemp-square.jpg";
import RecotexImage from "./assets/recotex-square.jpg";

// Local Styling
import "./sustainability.css";

class Sustainability extends React.Component {
  render() {
    return (
      <div className="content sustainability">
        <DashedLineBreakHeader title="Our Approach to Sustainability" first />
        <p>
          Sustainability is a broad and generic term, there is currently no
          industry certification nor standardized definition for it. As a means
          of defining our practice we decided to base our approach to
          sustainability on{" "}
          <a
            href="http://www.tedresearch.net/teds-ten/"
            target="_blank"
            rel="noopener noreferrer"
          >
            TED’s Ten
          </a>
          . Here are five out of the ten categories we currently fulfill:
        </p>
        <a href="http://www.tedresearch.net/1-minimise-waste/">
          <DashedLineBreakHeader title="1. Design to Minimize Waste" />
        </a>
        <div className="columns">
          <div className="column">
            <p>Zero Waste Design</p>
          </div>
          <div className="column">
            <p>
              Our pattern pieces are are cut and fit together without regard to
              the painted fabric design so that no fabric is wasted during the
              cutting phase; resulting in a one-of-a-kind visually unique
              product.
            </p>
            <p>
              We keep all fabric scraps to be used for small pattern pieces
              and/or to be recycled into accessories. HECHA / 做 Accessories
              line coming soon!
            </p>
          </div>
        </div>
        <div className="columns">
          <div className="column">
            <p>Long Life Designs</p>
          </div>
          <div className="column">
            <p>
              We create garments with longevity in mind, by using durable
              materials and high quality construction for wear and tear.
            </p>
            <p>
              We include functional design elements on the garments such as
              additional secret pockets and straps to enhance useability of the
              product.
            </p>
          </div>
        </div>
        <a href="http://www.tedresearch.net/3-reduce-chemical-impacts/">
          <DashedLineBreakHeader title="3. Design to Reduce Chemical Impact" />
        </a>
        <div className="columns">
          <div className="column">
            <Image src={HempImage} />
          </div>
          <div className="column">
            <p>Composition:</p>
            <p>45% Hemp</p>
            <p>40% Organic Cotton</p>
            <p>15% Recycled Poly Muslin</p>
            <p>Color: Greige/Natural with hand-painted surface</p>
          </div>
        </div>
        <div className="columns">
          <div className="column">
            <Image src={RecotexImage} />
          </div>
          <div className="column">
            <p>Composition:</p>
            <p>88% Recycled Recotex Poly </p>
            <p>12% Spandex with Max-Drimoisture management technology</p>
            <p>Color: Black</p>
          </div>
        </div>
        <p>
          Our main line is constructed from hand-painted, unbleached greige hemp
          fabric. By working with the hemp in it’s unprocessed greige state we
          are reducing the chemical impact the fabric has on the environment.
          The density of the hemp plant also chokes out competing plants meaning
          less harsh chemical herbicides and pesticides are needed in the
          cultivation process.
        </p>
        <p>
          The ink used to paint the fabric is Permaset Aqua; a water-based,
          non-toxic screen printing ink. The ink is 100% solvent free and can be
          air dried or heat cured and set without the use of any fixatives. As a
          water-based product, Permaset Aqua is low in odour and easily cleaned
          with water.
        </p>
        <div className="quote">
          <p>
            “Permaset Aqua inks do not contain ozone-depleting chemicals such as
            CFC’s and HCFC’s, aromatic hydrocarbons or any volatile solvents.
            They don’t contain lead or any heavy metals. In fact,Permaset Aqua
            inks do not contain any toxic chemicals at all! Not even white
            spirits like other water based inks on the market. It passed the
            Oekotex Class 1 standard (with 60% to spare!) and is safe to use on
            underwear, swimwear and even baby clothes.”
          </p>
          <p>
            <a href="https://www.permaset.com.au/why-water-based-inks/">
              Permaset Aqua
            </a>
          </p>
        </div>
        <p>
          Our activewear line is made with recycled polyester instead of
          traditional spandex. The activewear pieces are made with this quick
          dry environmentally conscious fabric in order to be worn comfortably
          as base-layers.
        </p>
        <a href="http://www.tedresearch.net/4-reduce-energy-and-water-use/">
          <DashedLineBreakHeader title="4. Design to Reduce Energy and Water Use" />
        </a>
        <div className="columns">
          <div className="column">
            <h3>Hemp</h3>
          </div>
          <div className="column">
            <p>
              Hemp is a densely growing plant that requires less land to
              cultivate and produce double the fiber yield per hectare than
              cotton.
            </p>
            <p>
              Hemp requires very little water to grow, especially compared to
              cotton which uses four times more water in the process. Hemp is
              also gentle on the earth, as it returns 60-70% of the nutrients it
              takes from the soil.
            </p>
          </div>
        </div>

        <div className="columns">
          <div className="column">
            <h3>Organic Cotton</h3>
          </div>
          <div className="column">
            <p>
              Organic cotton is grown using methods and materials that have a
              low impact on the environment. Organic production systems
              replenish and maintain soil fertility, reduce the use of toxic and
              persistent pesticides and fertilizers, and build biologically
              diverse agriculture.
            </p>
          </div>
        </div>

        <div className="columns">
          <div className="column">
            <h3>Recycled PET Fabric</h3>
          </div>
          <div className="column">
            <p>
              Recycling of PET bottles can help slow global warming and save our
              planet by reducing environmental pollution, cutting back on fossil
              fuel and energy consumption, and decreasing CO2 emissions.
            </p>
          </div>
        </div>

        <div className="columns">
          <div className="column">
            <h3>Fabric Care</h3>
          </div>
          <div className="column">
            <p>
              We suggest washing our clothes with cold water and line drying to
              reduce energy use.
            </p>
            <p>Dry cleaning is not necessary or required</p>
          </div>
        </div>

        <a href="http://www.tedresearch.net/7-consider-ethical-and-fair-trade-production/">
          <DashedLineBreakHeader title="7. Design for Ethical Production" />
        </a>
        <p>
          We work with suppliers and manufacturers that are committed to ethical
          production. Our local garment industry production partners are studios
          and/or factories that we have handpicked to build relationships with
          after visiting and meeting on-site.
        </p>
        <p>
          We have chosen to source our dominant raw material (the fabric for our
          main line) from a business that engages in fair and free trade
          production:
        </p>
        <div className="quote">
          <p>
            "Since hemp is currently illegal to grow in the United States, all
            of our hemp products need to be imported from other countries such
            as China, Romania, and Canada. We have visited the farms and
            factories in these countries to ensure they adhere to fair trade
            practices with all people involved. These include the following:"
          </p>

          <p>
            Reasonable wages: Wages are negotiated on a free and fair basis and
            are adequate to ensure a decent standard of living for all
            employees.
          </p>

          <p>
            Reasonable hours: Employees work an average of 40-60 hours a week
            depending upon their work load and personal needs. Employees are
            allowed regular breaks and lunch time.
          </p>

          <p>
            Safe and comfortable working conditions: Workers conditions include
            adequate lighting, comfortable temperature, chairs and
            desks.Machinery is properly maintained with instructions given for
            safe and proper use.
          </p>

          <p>Our China factory is also a member of the Fair Wear Foundation</p>

          <p>
            <a href="https://www.hemptraders.com/Fair-Trade-s/1860.htm">
              Hemp Traders
            </a>
          </p>
        </div>
        <a href="http://www.tedresearch.net/8-replace-need-consume/">
          <DashedLineBreakHeader title="8. Design to Reduce the Need to Consume" />
        </a>
        <p>
          We are consciously reverting our mentality and relationship with
          clothing back to a time when garments were meticulously taken care of
          and often mended in order to last a lifetime. By making our pieces
          less disposable in nature we hope to encourage consumers to collect
          clothing that is durable in order to reduce waste in the industry.
        </p>

        <p>
          Our main line garments are made with a fabric that improves in texture
          the more it is handled making them adaptable to change with age. The
          painted surface of each piece adds thick textures and reinforces the
          durability of the design. The visual aesthetic of the painted textures
          makes it so that any debris or stains that may accumulate are less
          noticeable and possibly even welcome additions to a lifelong patina.
        </p>

        <p>
          Our activewear line garments are made with a heavyweight recycled
          polyester that is highly resistant to overstretching and easily
          returns to its original shape. The strength of the weave and thickness
          of the fabric gives it an almost neoprene-like quality for extra
          durability.
        </p>

        <p>
          The theory is to slow down the rapid cycling fashion seasons by
          creating high quality garments that are made sustainably with added
          aesthetic value to increase their longevity.
        </p>
      </div>
    );
  }
}
export default Sustainability;
